import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useLocation } from 'quartz-routing/react-router';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import InterstitialContentViewport from './InterstitialContentViewport';
import { BaseContentControlWrapper } from '../ContentControlWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BasicInterstitial = ({
  buttonLink,
  buttonI18n,
  buttonUse = 'primary',
  headingI18n,
  hideButton = false,
  onButtonClick = () => {},
  pictogramName,
  subheadingI18n,
  testId = 'interstitial'
}) => {
  const location = useLocation();
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": testId,
    children: [/*#__PURE__*/_jsx(InterstitialContentViewport, {
      viewportStyles: {
        padding: '50px',
        textAlign: 'center'
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        minBlockSize: "350px",
        children: [/*#__PURE__*/_jsx(Pictogram, {
          name: pictogramName
        }), /*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockStart: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: headingI18n
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockStart: "500",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: subheadingI18n
          })
        })]
      })
    }), !hideButton && /*#__PURE__*/_jsx(BaseContentControlWrapper, {
      children: buttonLink ? /*#__PURE__*/_jsx(RouterButton, {
        onClick: onButtonClick,
        to: Object.assign({}, location, {
          pathname: buttonLink
        }),
        use: buttonUse,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: buttonI18n
        })
      }) : /*#__PURE__*/_jsx(Button, {
        onClick: onButtonClick,
        use: buttonUse,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: buttonI18n
        })
      })
    })]
  });
};
export default BasicInterstitial;